import { Injectable } from '@angular/core';
import { Adapter } from '../adapter.service';
import { SettingMonitorOutpatientQueue } from 'src/app/shared/models/antrian/setting-monitor-outpatient-queue.model';

@Injectable({
  providedIn: 'root',
})
export class SettingMonitorOutpatientQueueAdapter
  implements Adapter<SettingMonitorOutpatientQueue>
{
  public adapt(item: any): SettingMonitorOutpatientQueue {
    return {
      idSettingMonitorPoliklinik: item.idSettingMonitorPoliklinik,
      instalationList: item.instalationList,
      color: item.color,
      socketRoute: item.socketRoute,
      settingStatus: item.settingStatus,
      settingNumber: item.settingNumber,
      dateMake: item.dateMake,
    };
  }
}
